var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 222.672,
    height: 222.585,
    viewBox: "0 0 222.672 222.585",
    id: "svg-uijw4g41rgl2p0ozo3z87j8glq3e1x00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-el-oz15xzoy30fa1ow1vaerr17cw9oif2id"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg-el-4qpytbwvppu7vp9xz9kr9dfqsi81qqya",
    "data-name": "Rectangle 2",
    width: 222.672,
    height: 222.585,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "svg-el-efi9xslhg8dzr60k89sxzjqhj2bz0lh4",
    "data-name": "Path 1",
    d: "M54.653,105.1H48.038v4.268h7.389V112.7H43.957V94.721h11.1v3.334H48.038v3.734h6.615Z",
    fill: "#ffffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg-el-imy9m7o8fmu9v2ft1e68lqjk34pk2o79",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg-el-2cs81wlt1cxa9pu1csndmp6tr09j97s2",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg-el-mxyvo88r1ulnjtu8kq8xo0xtolt6oucz",
    "data-name": "Path 2",
    d: "M66.866,112.7l-1.627-3.255c-.667-1.253-1.094-2.187-1.6-3.227h-.053c-.373,1.04-.827,1.974-1.387,3.227L60.7,112.7H56.063l5.2-9.1-5.015-8.882h4.669L62.491,98c.534,1.093.934,1.974,1.361,2.987H63.9c.427-1.146.774-1.946,1.227-2.987l1.521-3.28h4.641L66.226,103.5l5.335,9.2Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-eme5e25t8xcc7afxga89lkkleqh9t61p",
    "data-name": "Path 3",
    d: "M72.944,94.96a33.336,33.336,0,0,1,5.5-.373c2.507,0,4.295.48,5.495,1.441a5.254,5.254,0,0,1,1.921,4.161,5.747,5.747,0,0,1-1.654,4.268,8.336,8.336,0,0,1-5.842,1.894,10.3,10.3,0,0,1-1.387-.08V112.7H72.944Zm4.028,8.163a6.215,6.215,0,0,0,1.36.107c2.161,0,3.5-1.094,3.5-2.934,0-1.655-1.147-2.641-3.175-2.641a6.932,6.932,0,0,0-1.68.16Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-v2bgce526ul0pihlqcgvi1h04at7m894",
    "data-name": "Path 4",
    d: "M90.226,108.085l-1.28,4.614H84.731l5.495-17.978h5.335l5.575,17.978H96.761l-1.387-4.614Zm4.561-3.041-1.12-3.815c-.32-1.067-.64-2.4-.907-3.467h-.054c-.266,1.066-.533,2.427-.826,3.467l-1.067,3.815Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-du35ged0j6uxl2zsyauhc4ylu5d8r88t",
    "data-name": "Path 5",
    d: "M102.732,112.7V94.722h4.748l3.735,6.588a52.2,52.2,0,0,1,2.934,6.162h.08a66.655,66.655,0,0,1-.347-7.5V94.722h3.734V112.7h-4.267l-3.842-6.936a67.152,67.152,0,0,1-3.121-6.348l-.08.027c.107,2.374.16,4.908.16,7.842V112.7Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-wpp8l2fl2o1maz4csyevdid5vgjcfwl8",
    "data-name": "Path 6",
    d: "M120.333,94.961a36.443,36.443,0,0,1,5.5-.373c3.414,0,5.627.613,7.362,1.921a7.955,7.955,0,0,1,3.041,6.774,9.112,9.112,0,0,1-2.989,7.282c-1.893,1.575-4.774,2.322-8.295,2.322a35.276,35.276,0,0,1-4.615-.267Zm4.081,14.671a7.4,7.4,0,0,0,1.415.081c3.681.026,6.081-2,6.081-6.3.027-3.735-2.161-5.708-5.655-5.708a8.548,8.548,0,0,0-1.841.159Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-9jg365gma69gspv2q4myxr2x2y1dq8kb",
    "data-name": "Path 7",
    d: "M144.6,112.7l-4.268-17.978h4.348l1.361,7.414c.4,2.135.772,4.455,1.066,6.269h.054c.293-1.947.72-4.107,1.173-6.322l1.52-7.361h4.322l1.441,7.575c.4,2.107.693,4.028.96,6.028h.053c.267-2,.667-4.108,1.04-6.242l1.467-7.361h4.135L158.633,112.7h-4.4l-1.52-7.735c-.347-1.814-.64-3.495-.854-5.549H151.8c-.32,2.028-.614,3.735-1.04,5.549l-1.707,7.735Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg-el-mofyfnibg4q4nt5qzqy7gufgphkpl2wb",
    "data-name": "Rectangle 1",
    width: 4.081,
    height: 17.978,
    transform: "translate(164.574 94.721)",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-b5eir6xp3ypgiu56uvbx65vqr37avi6f",
    "data-name": "Path 8",
    d: "M174.842,98.135h-4.828V94.721h13.817v3.414h-4.908V112.7h-4.081Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-clbei1m1v1iee2zqjbvu4r0hdqrwn9tk",
    "data-name": "Path 9",
    d: "M189.269,94.721v6.909h6.7V94.721h4.054V112.7h-4.054v-7.522h-6.7V112.7h-4.081V94.721Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-3hssevmwl317ky0wco1hojhjkgr3tv5b",
    "data-name": "Path 10",
    d: "M220.054,219.968H2.617V2.618H220.054ZM222.672,0H0V222.585H222.585V0Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-wm1prrwb6jvu96vjkbep3jsx5qf0ylx2",
    "data-name": "Path 11",
    d: "M43.609,181.765l-5.268,18.987H21L43.609,126.78h21.95L88.5,200.752h-18l-5.706-18.987Zm18.767-12.511-4.609-15.695c-1.318-4.389-2.634-9.877-3.732-14.267h-.219c-1.1,4.39-2.2,9.987-3.4,14.267l-4.39,15.695Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-abl2shb27rf5xiekphh19qk5galxrn29",
    "data-name": "Path 12",
    d: "M146.661,198.667c-3.073,1.536-9.988,3.183-18.987,3.183-25.572,0-38.742-15.914-38.742-36.986,0-25.243,18-39.291,40.389-39.291,8.669,0,15.255,1.756,18.218,3.292l-3.4,13.28a36.124,36.124,0,0,0-14.048-2.744c-13.28,0-23.6,8.013-23.6,24.474,0,14.817,8.78,24.146,23.706,24.146a41.8,41.8,0,0,0,13.939-2.414Z",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-el-bis2e6eambuv0epcdzn9id353q0ml3li",
    "data-name": "Path 13",
    d: "M198.349,169.473H171.131v17.56h30.4v13.719H154.339V126.78H200V140.5H171.131v15.365h27.218Z",
    fill: "#ffffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.bfc2b1024343189128d4f96e70738739.svg";
export { ForwardRef as ReactComponent };